import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Chip,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  CircularProgress,
  Card,
  CardContent,
  Divider,
  Badge,
  Tabs,
  Tab,
  InputAdornment,
  Stepper,
  Step,
  StepLabel,
  Stack
} from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  DirectionsBike,
  Person,
  CalendarToday,
  AttachMoney,
  FilterList,
  Search,
  PersonAdd,
  Remove,
  Add,
  AssignmentInd as AssignmentIndIcon,
  Event,
  AccessTime,
  TwoWheeler,
  Receipt,
  CheckCircle,
  Info,
  ChevronLeft,
  ChevronRight
} from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { it } from 'date-fns/locale';
import {
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  eachDayOfInterval,
  addMonths,
  subMonths,
  format,
  isSameDay,
  differenceInDays,
  isBefore,
  isAfter
} from 'date-fns';
import { generateRentalContractPDF } from '../../utils/rentalContractPDF';
import { api } from '../../utils/api';
import { useCompany } from '../../contexts/CompanyContext';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import BatteryFullIcon from '@mui/icons-material/BatteryFull';
import PrintIcon from '@mui/icons-material/Print';

const RentalManagement = () => {
  const { currentCompany } = useCompany();
  const [rentals, setRentals] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [companySettings, setCompanySettings] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingRental, setEditingRental] = useState(null);
  const [rentalStep, setRentalStep] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [activeTab, setActiveTab] = useState(0);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [newCustomerDialog, setNewCustomerDialog] = useState(false);
  const [customerSearchQuery, setCustomerSearchQuery] = useState('');
  const [customerSearchResults, setCustomerSearchResults] = useState([]);
  const [customerSearchAttempted, setCustomerSearchAttempted] = useState(false);
  const [dateRangeHover, setDateRangeHover] = useState(null);
  const [calendarMonth, setCalendarMonth] = useState(new Date());
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [paymentDialog, setPaymentDialog] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [paymentData, setPaymentData] = useState({
    paymentMethodId: '',
    accountId: '',
    amount: 0, // Importo pagato
    sconto: 0, // Campo opzionale per sconto
    notes: ''
  });
  const [returnDialog, setReturnDialog] = useState(false);
  const [returnData, setReturnData] = useState({
    rentalId: null,
    rentalGroupId: null,
    vehicles: [], // Array di { vehicleId, vehicleName, batteryLevel, km }
    notes: '',
    totalDeposit: 0
  });
  const [viewRentalDialog, setViewRentalDialog] = useState(false);
  const [viewingRentalGroup, setViewingRentalGroup] = useState(null);
  const [documentDialog, setDocumentDialog] = useState(false);
  const [completePaymentDialog, setCompletePaymentDialog] = useState(false);
  const [rentalToStart, setRentalToStart] = useState(null);
  const [completePaymentData, setCompletePaymentData] = useState({
    paymentMethodId: '',
    accountId: '',
    amount: 0,
    notes: ''
  });
  const [documentData, setDocumentData] = useState({
    documentType: 'Carta di Identità',
    documentNumber: '',
    documentIssueDate: null,
    documentExpiryDate: null,
    documentIssuedBy: ''
  });

  const [formData, setFormData] = useState({
    customerId: '',
    customerName: '',
    rentalVehicleId: '',
    startDate: new Date(),
    endDate: new Date(Date.now() + 24 * 60 * 60 * 1000), // 24 ore da ora
    startTime: new Date(),
    endTime: new Date(Date.now() + 24 * 60 * 60 * 1000),
    tariffType: 'giornaliero',
    tariffPrice: 25.00,
    quantity: 1,
    totalPrice: '',
    status: 'active',
    notes: '',
    cauzione: 0 // Cauzione opzionale
  });

  const [newCustomerData, setNewCustomerData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    postalCode: '',
    notes: '',
    countryCode: '39'
  });
  const [customerFormErrors, setCustomerFormErrors] = useState({});
  const [tariffOptions, setTariffOptions] = useState([
    { value: 'giornaliero', label: 'Giornaliero', price: 25.00, duration: 1, unit: 'giorni' },
    { value: 'settimanale', label: 'Settimanale', price: 20.00, duration: 7, unit: 'settimane' },
    { value: 'mensile', label: 'Mensile', price: 11.67, duration: 30, unit: 'mesi' }
  ]);
  const [discountRates, setDiscountRates] = useState({
    1: 0,    // Nessuno sconto
    2: 0.10, // 10% sul secondo
    3: 0.15, // 15% sul terzo
    4: 0.20, // 20% sul quarto
    5: 0.25  // 25% sul quinto
  });

  useEffect(() => {
    fetchData();
    fetchCompanySettings();
    
    // Ascolta gli aggiornamenti delle impostazioni di noleggio
    const handleSettingsUpdate = () => {
      fetchCompanySettings();
    };
    
    window.addEventListener('rentalSettingsUpdated', handleSettingsUpdate);
    
    return () => {
      window.removeEventListener('rentalSettingsUpdated', handleSettingsUpdate);
    };
  }, []);

  const fetchCompanySettings = async () => {
    try {
      console.log('📄 Caricamento impostazioni aziendali per contratto...');
      let response = await api.get('/company-settings');
      
      if (!response.data || Object.keys(response.data).length === 0) {
        console.log('📄 Nessun dato trovato in /company-settings, provo con /settings');
        response = await api.get('/settings');
      }
      
      if (response.data) {
        const settings = {};
        Object.entries(response.data).forEach(([key, value]) => {
          settings[key] = value;
        });
        
        console.log('📄 Impostazioni aziendali caricate:', settings);
        setCompanySettings(settings);
        
        // Aggiorna le tariffe di noleggio dalle impostazioni
        const dailyPrice = parseFloat(settings.rentalDailyPrice || 25.00);
        const weeklyPrice = parseFloat(settings.rentalWeeklyPrice || 20.00);
        const monthlyPrice = parseFloat(settings.rentalMonthlyPrice || 11.67);
        
        setTariffOptions([
          { value: 'giornaliero', label: 'Giornaliero', price: dailyPrice, duration: 1, unit: 'giorni' },
          { value: 'settimanale', label: 'Settimanale', price: weeklyPrice, duration: 7, unit: 'settimane' },
          { value: 'mensile', label: 'Mensile', price: monthlyPrice, duration: 30, unit: 'mesi' }
        ]);
        
        // Carica i livelli di sconto
        let discountLevels = [];
        if (settings.rentalDiscountLevels) {
          try {
            discountLevels = JSON.parse(settings.rentalDiscountLevels);
          } catch (e) {
            console.error('Error parsing discount levels:', e);
            discountLevels = [{ numeroVeicoli: 2, percentuale: 10 }];
          }
        } else {
          // Fallback ai vecchi valori se non esistono livelli
          const discountPercentage = parseFloat(settings.rentalDiscountPercentage || 10);
          const minVehicles = parseInt(settings.rentalMinVehiclesForDiscount || 2);
          discountLevels = [{ numeroVeicoli: minVehicles, percentuale: discountPercentage }];
        }
        
        // Crea un oggetto discountRates per compatibilità con il codice esistente
        // La funzione getDiscountForVehicles userà direttamente i livelli
        const newDiscountRates = {};
        const maxVeicoli = Math.max(...discountLevels.map(l => parseInt(l.numeroVeicoli) || 0), 20);
        for (let i = 1; i <= maxVeicoli; i++) {
          // Trova il livello di sconto appropriato per questo numero di veicoli
          const applicableLevel = discountLevels
            .filter(l => parseInt(l.numeroVeicoli) <= i)
            .sort((a, b) => parseInt(b.numeroVeicoli) - parseInt(a.numeroVeicoli))[0];
          
          if (applicableLevel) {
            newDiscountRates[i] = parseFloat(applicableLevel.percentuale) / 100;
          } else {
            newDiscountRates[i] = 0;
          }
        }
        setDiscountRates(newDiscountRates);
        
        // Salva anche i livelli per uso diretto
        setCompanySettings({ ...settings, rentalDiscountLevelsParsed: discountLevels });
        
        // Aggiorna anche il prezzo iniziale nel form se è giornaliero
        if (formData.tariffType === 'giornaliero') {
          setFormData(prev => ({ ...prev, tariffPrice: dailyPrice }));
        }
      }
    } catch (err) {
      console.error('❌ Errore nel caricamento delle impostazioni aziendali:', err);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const [rentalsRes, customersRes, vehiclesRes, paymentMethodsRes, accountsRes] = await Promise.all([
        api.get('/rentals'),
        api.get('/customers'),
        api.get('/rental-vehicles'),
        api.get('/payment-methods'),
        api.get('/accounts')
      ]);
      
      setRentals(rentalsRes.data);
      setCustomers(customersRes.data);
      // Carica tutti i veicoli - la disponibilità sarà verificata in base alle date dei noleggi
      setVehicles(vehiclesRes.data);
      setPaymentMethods(paymentMethodsRes.data);
      setAccounts(accountsRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
      setError('Errore nel caricamento dei dati');
    } finally {
      setLoading(false);
    }
  };

  const handleSaveRental = async () => {
    try {
      const vehicleIds = selectedVehicles.filter(v => v.vehicleId).map(v => v.vehicleId);
      if (!vehicleIds.length) {
        setError('Seleziona almeno un veicolo');
        return;
      }

      const rentalData = {
        customerId: formData.customerId,
        startDate: formData.startDate,
        endDate: formData.endDate,
        dailyRate: formData.tariffPrice,
        totalAmount: calculateTotalPrice(),
        status: formData.status,
        notes: formData.notes
      };
      if (editingRental) {
        // Invia sempre vehicleIds (array) per gestire correttamente noleggi singoli e multipli
        rentalData.vehicleIds = vehicleIds;
        await api.put(`/rentals/${editingRental.id}`, rentalData);
        await fetchData();
        setDialogOpen(false);
        resetForm();
      } else {
        setPaymentData({
          paymentMethodId: '',
          accountId: '',
          amount: calculateTotalPrice(),
          sconto: 0,
          notes: ''
        });
        setPaymentDialog(true);
      }
    } catch (error) {
      console.error('Error saving rental:', error);
      setError('Errore nel salvataggio del noleggio');
    }
  };

  const handleStartRental = async (rentalId) => {
    try {
      // Trova il noleggio
      const rental = rentals.find(r => r.id === rentalId);
      if (!rental) {
        setError('Noleggio non trovato');
        return;
      }
      
      // Se c'è un rentalGroupId, trova tutti i rental del gruppo per calcolare correttamente il totale
      const groupRentals = rental.rentalGroupId
        ? rentals.filter(r => r.rentalGroupId === rental.rentalGroupId)
        : [rental];
      
      // Calcola il totale considerando tutti i veicoli del gruppo
      const totalAmount = groupRentals.reduce((sum, r) => sum + parseFloat(r.totalAmount || 0), 0);
      const totalDiscount = groupRentals.reduce((sum, r) => sum + parseFloat(r.sconto || 0), 0);
      const totalPaid = groupRentals.reduce((sum, r) => sum + parseFloat(r.totalePagato || 0), 0);
      const totalAfterDiscount = totalAmount - totalDiscount;
      const allPaid = groupRentals.every(r => r.saldato === true);
      
      // Controlla se il noleggio è stato saldato
      if (!allPaid) {
        // Se non è saldato, apri il dialog per completare il pagamento
        // Usa il primo rental come riferimento, ma con i totali corretti del gruppo
        setRentalToStart({
          ...rental,
          totalAmount: totalAmount,
          sconto: totalDiscount,
          totalePagato: totalPaid
        });
        setCompletePaymentData({
          paymentMethodId: '',
          accountId: '',
          amount: totalAfterDiscount - totalPaid,
          notes: ''
        });
        setCompletePaymentDialog(true);
        return;
      }
      
      // Se è saldato, avvia tutti i rental del gruppo
      for (const r of groupRentals) {
        await api.put(`/rentals/${r.id}`, { status: 'active' });
      }
      await fetchData();
      console.log('✅ Noleggio avviato');
    } catch (error) {
      console.error('❌ Errore nell\'avvio del noleggio:', error);
      setError('Errore nell\'avvio del noleggio');
    }
  };
  
  const handleCompletePaymentAndStart = async () => {
    try {
      if (!rentalToStart) return;
      
      if (!completePaymentData.paymentMethodId || !completePaymentData.accountId || completePaymentData.amount <= 0) {
        setError('Compila tutti i campi del pagamento');
        return;
      }
      
      // Trova tutti i rental del gruppo se esiste
      const groupRentals = rentalToStart.rentalGroupId
        ? rentals.filter(r => r.rentalGroupId === rentalToStart.rentalGroupId)
        : [rentalToStart];
      
      // Calcola il totale pagato attuale sommando tutti i rental del gruppo
      const totalePagatoAttualeGruppo = groupRentals.reduce((sum, r) => sum + parseFloat(r.totalePagato || 0), 0);
      
      // Calcola il nuovo totale pagato considerando lo sconto
      const totaleConSconto = parseFloat(rentalToStart.totalAmount || 0) - parseFloat(rentalToStart.sconto || 0);
      const nuovoTotalePagatoGruppo = totalePagatoAttualeGruppo + parseFloat(completePaymentData.amount);
      const saldato = nuovoTotalePagatoGruppo >= totaleConSconto;
      
      // Dividi il nuovo totale pagato per il numero di rental nel gruppo
      const nuovoTotalePagatoPerRental = nuovoTotalePagatoGruppo / groupRentals.length;
      
      // Aggiorna tutti i rental del gruppo con il pagamento
      for (const rental of groupRentals) {
        await api.put(`/rentals/${rental.id}`, {
          totalePagato: nuovoTotalePagatoPerRental,
          saldato
        });
      }
      
      // Crea il movimento contabile
      const vehicleNames = groupRentals.map(r => {
        const v = vehicles.find(vv => vv.id === r.vehicleId);
        return v?.name || 'Veicolo';
      }).join(', ');
      
      const accountingData = {
        type: 'IN',
        amount: completePaymentData.amount,
        description: groupRentals.length > 1 
          ? `Completamento pagamento noleggio - ${vehicleNames}`
          : `Completamento pagamento noleggio - ${vehicleNames}`,
        date: new Date().toISOString().split('T')[0],
        paymentMethodId: completePaymentData.paymentMethodId,
        accountId: completePaymentData.accountId,
        source: 'rental',
        sourceId: rentalToStart.id
      };
      
      await api.post('/accounting-movements', accountingData);
      
      // Ora avvia tutti i rental del gruppo
      for (const rental of groupRentals) {
        await api.put(`/rentals/${rental.id}`, { status: 'active' });
      }
      
      await fetchData();
      setCompletePaymentDialog(false);
      setRentalToStart(null);
      setCompletePaymentData({
        paymentMethodId: '',
        accountId: '',
        amount: 0,
        notes: ''
      });
      console.log('✅ Pagamento completato e noleggio avviato');
    } catch (error) {
      console.error('❌ Errore nel completamento pagamento:', error);
      setError('Errore nel completamento del pagamento');
    }
  };

  const handleReturnRental = (rentalId) => {
    const rental = rentals.find(r => r.id === rentalId);
    if (!rental) return;
    
    // Trova tutti i rental del gruppo se esiste
    const groupRentals = rental.rentalGroupId
      ? rentals.filter(r => r.rentalGroupId === rental.rentalGroupId)
      : [rental];
    
    // Calcola la cauzione totale sommando tutte le cauzioni del gruppo
    const totalDeposit = groupRentals.reduce((sum, r) => sum + parseFloat(r.cauzione || 0), 0);
    
    // Prepara i dati per ogni veicolo
    const vehiclesData = groupRentals.map(r => {
      const vehicle = vehicles.find(v => v.id === r.vehicleId);
      return {
        vehicleId: r.vehicleId,
        rentalId: r.id,
        vehicleName: vehicle?.name || 'N/A',
        batteryLevel: vehicle?.batteryLevel || 100,
        km: vehicle?.totalKm || 0
      };
    });
    
    setReturnData({
      rentalId: rentalId,
      rentalGroupId: rental.rentalGroupId,
      vehicles: vehiclesData,
      notes: '',
      totalDeposit: totalDeposit
    });
    setReturnDialog(true);
  };

  const handleConfirmReturn = async () => {
    try {
      const { rentalId, rentalGroupId, vehicles, notes } = returnData;
      
      // Trova tutti i rental del gruppo
      const groupRentals = rentalGroupId
        ? rentals.filter(r => r.rentalGroupId === rentalGroupId)
        : [rentals.find(r => r.id === rentalId)];
      
      // Aggiorna tutti i noleggi del gruppo a completato
      for (const rental of groupRentals) {
        await api.put(`/rentals/${rental.id}`, { 
          status: 'completed',
          notes: notes || null
        });
      }
      
      // Aggiorna ogni veicolo con batteria e km
      for (const vehicleData of vehicles) {
        await api.put(`/rental-vehicles/${vehicleData.vehicleId}`, {
          status: 'available',
          batteryLevel: vehicleData.batteryLevel,
          totalKm: vehicleData.km
        });
      }
      
      await fetchData();
      setReturnDialog(false);
      setReturnData({ 
        rentalId: null, 
        rentalGroupId: null,
        vehicles: [], 
        notes: '',
        totalDeposit: 0
      });
      console.log('✅ Noleggio completato e veicoli resi disponibili');
    } catch (error) {
      console.error('❌ Errore nella riconsegna:', error);
      setError('Errore nella riconsegna del veicolo');
    }
  };

  const handlePayment = async () => {
    try {
      console.log('🚀 Inizio processamento pagamento');
      console.log('📊 paymentData:', paymentData);
      console.log('📊 selectedVehicles:', selectedVehicles);
      
      const firstVehicle = selectedVehicles.find(v => v.vehicleId);
      console.log('🚗 firstVehicle:', firstVehicle);
      
      if (!firstVehicle) {
        throw new Error('Nessun veicolo selezionato');
      }
      
      if (!paymentData.paymentMethodId || !paymentData.accountId) {
        throw new Error('Metodo di pagamento e conto sono obbligatori');
      }

      // Verifica se il cliente ha i dati del documento
      const customerData = customers.find(c => c.id === formData.customerId);
      if (!customerData.documentType || !customerData.documentNumber) {
        console.log('⚠️ Documenti mancanti, apro dialog per richiederli');
        // Popola i dati esistenti se presenti
        setDocumentData({
          documentType: customerData.documentType || 'Carta di Identità',
          documentNumber: customerData.documentNumber || '',
          documentIssueDate: customerData.documentIssueDate || null,
          documentExpiryDate: customerData.documentExpiryDate || null,
          documentIssuedBy: customerData.documentIssuedBy || ''
        });
        setDocumentDialog(true);
        return; // Ferma l'esecuzione, riprenderà dopo aver salvato i documenti
      }

      // Procedi con il pagamento
      await processPaymentAndContract();
    } catch (error) {
      console.error('❌ Error processing payment:', error);
      setError(error.message || 'Errore durante il pagamento');
    }
  };

  const processPaymentAndContract = async () => {
    try {
      const vehicleIds = selectedVehicles.filter(v => v.vehicleId).map(v => v.vehicleId);
      const firstVehicle = selectedVehicles.find(v => v.vehicleId);
      const vehicleNames = selectedVehicles
        .filter(v => v.vehicleId)
        .map(v => vehicles.find(ve => ve.id === v.vehicleId)?.name)
        .filter(Boolean)
        .join(', ');
      
      // Calcola i dati di pagamento
      const totaleNoleggio = calculateTotalPrice();
      const scontoApplicato = paymentData.sconto || 0;
      const totaleConSconto = totaleNoleggio - scontoApplicato;
      const importoPagato = paymentData.amount || 0;
      
      // Determina automaticamente se è acconto o pagamento totale
      const isAcconto = importoPagato < totaleConSconto;
      const totalePagato = importoPagato;
      const saldato = !isAcconto && importoPagato >= totaleConSconto;
      const accontoVersato = isAcconto ? importoPagato : 0;
      
      const rentalData = {
        customerId: formData.customerId,
        vehicleIds,
        startDate: formData.startDate,
        endDate: formData.endDate,
        dailyRate: formData.tariffPrice,
        totalAmount: totaleNoleggio,
        status: formData.status,
        notes: formData.notes,
        totalePagato,
        acconto: accontoVersato,
        sconto: scontoApplicato,
        cauzione: formData.cauzione || 0, // La cauzione viene dallo step dedicato
        saldato
      };
      
      const rentalResponse = await api.post('/rentals', rentalData);
      const created = rentalResponse.data.rentals || [rentalResponse.data];
      const firstRentalId = Array.isArray(created) ? created[0]?.id : rentalResponse.data?.id;
      
      // Crea movimento contabile solo se è stato pagato qualcosa
      if (totalePagato > 0) {
        const descParts = [];
        if (isAcconto) descParts.push('Acconto');
        if (scontoApplicato > 0) descParts.push(`Sconto €${scontoApplicato.toFixed(2)}`);
        const descSuffix = descParts.length > 0 ? ` (${descParts.join(', ')})` : '';
        
        const accountingData = {
          type: 'IN',
          amount: totalePagato,
          description: vehicleIds.length > 1 
            ? `Noleggio - ${vehicleNames}${descSuffix}`
            : `Noleggio - ${firstVehicle?.vehicleName || vehicleNames || 'Veicolo'}${descSuffix}`,
          date: new Date().toISOString().split('T')[0],
          paymentMethodId: paymentData.paymentMethodId,
          accountId: paymentData.accountId,
          source: 'rental',
          sourceId: firstRentalId
        };
        
        console.log('💰 Creazione movimento contabile con dati:', accountingData);
        
        // Crea i movimenti contabili
        const accountingResponse = await api.post('/accounting-movements', accountingData);
        console.log('✅ Movimento contabile creato:', accountingResponse.data);
      }
      
      // Genera il PDF del contratto
      console.log('📄 Generazione PDF contratto...');
      const customerData = customers.find(c => c.id === formData.customerId);
      const vehiclesData = selectedVehicles
        .filter(v => v.vehicleId)
        .map(v => vehicles.find(ve => ve.id === v.vehicleId))
        .filter(Boolean);
      const companyData = {
        name: companySettings.companyName || 'ELEMOVE SRLS',
        address: `${companySettings.companyAddress || ''} ${companySettings.companyPostalCode || ''} ${companySettings.companyCity || ''}`.trim() || 'VIA RAIOLA 19 80053 CASTELLAMMARE DI STABIA',
        vatNumber: companySettings.companyVatNumber || '09624041217',
        phone: companySettings.companyPhone || '+39 081 123 4567',
        email: companySettings.companyEmail || 'info@elemove.it'
      };
      
      const contractData = {
        startDate: formData.startDate,
        endDate: formData.endDate,
        totalAmount: calculateTotalPrice(),
        tariffType: formData.tariffType,
        tariffPrice: formData.tariffPrice
      };
      
      generateRentalContractPDF(contractData, customerData, vehiclesData, companyData);
      console.log('✅ PDF contratto generato');
      
      await fetchData();
      setDialogOpen(false);
      setPaymentDialog(false);
      resetForm();
      
      console.log('🎉 Pagamento completato con successo');
    } catch (error) {
      console.error('❌ Error processing payment:', error);
      console.error('❌ Error details:', error.response?.data);
      setError(`Errore nel processamento del pagamento: ${error.message}`);
    }
  };

  const handleSaveDocuments = async () => {
    try {
      if (!documentData.documentType || !documentData.documentNumber) {
        setError('Tipo documento e numero documento sono obbligatori');
        return;
      }

      console.log('📄 Salvataggio documenti cliente:', documentData);

      // Aggiorna il cliente con i dati del documento
      await api.put(`/customers/${formData.customerId}`, {
        documentType: documentData.documentType,
        documentNumber: documentData.documentNumber,
        documentIssueDate: documentData.documentIssueDate,
        documentExpiryDate: documentData.documentExpiryDate,
        documentIssuedBy: documentData.documentIssuedBy
      });

      console.log('✅ Documenti salvati con successo');

      // Ricarica i dati del cliente specifico per avere i documenti aggiornati
      const updatedCustomerResponse = await api.get(`/customers/${formData.customerId}`);
      const updatedCustomer = updatedCustomerResponse.data;
      
      // Aggiorna l'array customers con i nuovi dati
      const updatedCustomers = customers.map(c => 
        c.id === updatedCustomer.id ? updatedCustomer : c
      );
      setCustomers(updatedCustomers);

      console.log('✅ Dati cliente aggiornati con documenti:', updatedCustomer);

      // Chiudi il dialog dei documenti
      setDocumentDialog(false);

      // Se siamo nello stepper del noleggio, procedi allo step successivo
      if (rentalStep === 0) {
        setRentalStep(1);
        setError(null);
      } else {
        // Altrimenti procedi con il pagamento e il contratto (caso vecchio)
        await processPaymentAndContract();
      }
    } catch (error) {
      console.error('❌ Errore nel salvataggio documenti:', error);
      setError(`Errore nel salvataggio documenti: ${error.message}`);
    }
  };

  const handleCustomerInputChange = (field) => (event) => {
    setNewCustomerData({ ...newCustomerData, [field]: event.target.value });
    // Clear error when user starts typing
    if (customerFormErrors[field]) {
      setCustomerFormErrors({ ...customerFormErrors, [field]: '' });
    }
  };

  const validateCustomerForm = () => {
    const errors = {};
    if (!newCustomerData.firstName.trim()) errors.firstName = 'Nome obbligatorio';
    if (!newCustomerData.lastName.trim()) errors.lastName = 'Cognome obbligatorio';
    if (!newCustomerData.email.trim()) errors.email = 'Email obbligatoria';
    else if (!/\S+@\S+\.\S+/.test(newCustomerData.email)) errors.email = 'Email non valida';
    if (!newCustomerData.phone.trim()) errors.phone = 'Telefono obbligatorio';
    setCustomerFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleCreateCustomer = async () => {
    if (!validateCustomerForm()) return;
    
    try {
      const response = await api.post('/customers', newCustomerData);
      setCustomers([...customers, response.data]);
      setFormData({ 
        ...formData, 
        customerId: response.data.id, 
        customerName: `${response.data.firstName} ${response.data.lastName}` 
      });
      setNewCustomerDialog(false);
      setNewCustomerData({ 
        firstName: '', 
        lastName: '', 
        email: '', 
        phone: '', 
        address: '', 
        city: '', 
        postalCode: '', 
        notes: '', 
        countryCode: '39' 
      });
      setCustomerFormErrors({});
    } catch (error) {
      console.error('Error creating customer:', error);
      setError('Errore nella creazione del cliente');
    }
  };

  const handleTariffChange = (tariffType) => {
    const tariff = tariffOptions.find(t => t.value === tariffType);
    const newEndDate = new Date(formData.startDate);
    
    // Calcola la data di fine in base alla tariffa e quantità (reset a 1)
    if (tariffType === 'giornaliero') {
      newEndDate.setDate(newEndDate.getDate() + 1);
    } else if (tariffType === 'settimanale') {
      newEndDate.setDate(newEndDate.getDate() + 7);
    } else if (tariffType === 'mensile') {
      newEndDate.setMonth(newEndDate.getMonth() + 1);
    }
    
    // Determina lo stato in base alla data di inizio
    const now = new Date();
    const startDateTime = new Date(formData.startDate);
    startDateTime.setHours(formData.startTime.getHours(), formData.startTime.getMinutes());
    const isScheduled = startDateTime > now;
    
    setFormData({
      ...formData,
      tariffType,
      tariffPrice: tariff.price,
      quantity: 1, // Reset quantità quando cambia tariffa
      endDate: newEndDate,
      endTime: newEndDate,
      status: isScheduled ? 'scheduled' : 'active'
    });
  };

  const updateStatusBasedOnDateTime = () => {
    const now = new Date();
    const startDateTime = new Date(formData.startDate);
    startDateTime.setHours(formData.startTime.getHours(), formData.startTime.getMinutes());
    const isScheduled = startDateTime > now;
    
    if (isScheduled && formData.status === 'active') {
      setFormData(prev => ({ ...prev, status: 'scheduled' }));
    } else if (!isScheduled && formData.status === 'scheduled') {
      setFormData(prev => ({ ...prev, status: 'active' }));
    }
  };

  // Calcola la tariffa migliore per un dato numero di giorni (prezzo minimo)
  const getBestTariffForDays = (days) => {
    if (!days || days < 1) return { tariffType: 'giornaliero', tariffPrice: tariffOptions[0]?.price ?? 25 };
    const daily = tariffOptions.find(t => t.value === 'giornaliero');
    const weekly = tariffOptions.find(t => t.value === 'settimanale');
    const monthly = tariffOptions.find(t => t.value === 'mensile');
    const dailyPrice = daily ? Number(daily.price) : 25;
    const weeklyPrice = weekly ? Number(weekly.price) : 20 * 7;
    const monthlyPrice = monthly ? Number(monthly.price) : 11.67 * 30;
    const costDaily = dailyPrice * days;
    const costWeekly = Math.ceil(days / 7) * weeklyPrice;
    const costMonthly = Math.ceil(days / 30) * monthlyPrice;
    if (costMonthly <= costWeekly && costMonthly <= costDaily)
      return { tariffType: 'mensile', tariffPrice: monthlyPrice };
    if (costWeekly <= costDaily)
      return { tariffType: 'settimanale', tariffPrice: weeklyPrice };
    return { tariffType: 'giornaliero', tariffPrice: dailyPrice };
  };

  const applyDateRangeFromCalendar = (clickedDate) => {
    const start = formData.startDate ? new Date(formData.startDate) : null;
    const end = formData.endDate ? new Date(formData.endDate) : null;
    const d = new Date(clickedDate);
    d.setHours(0, 0, 0, 0);
    const hasRange = start && end && !isSameDay(start, end);
    const onlyStartSelected = start && end && isSameDay(start, end);
    if (!start || hasRange) {
      // Nessuna selezione oppure hai già un intervallo: questo clic avvia una nuova selezione (solo inizio)
      const best = getBestTariffForDays(1);
      setFormData(prev => ({
        ...prev,
        startDate: d,
        endDate: d,
        endTime: d,
        startTime: d,
        quantity: 1,
        tariffType: best.tariffType,
        tariffPrice: best.tariffPrice
      }));
      setDateRangeHover(null);
      setTimeout(updateStatusBasedOnDateTime, 100);
      return;
    }
    if (onlyStartSelected && !isSameDay(d, start)) {
      // Avevi solo l'inizio (stesso giorno): questo clic imposta la data di fine
      let startD = new Date(start);
      let endD = new Date(d);
      startD.setHours(0, 0, 0, 0);
      endD.setHours(0, 0, 0, 0);
      if (isBefore(endD, startD)) [startD, endD] = [endD, startD];
      // Calcolo giorni: dal 24 al 25 sono 1 giorno (24 ore), non 2
      const days = differenceInDays(endD, startD);
      const best = getBestTariffForDays(days);
      setFormData(prev => ({
        ...prev,
        endDate: endD,
        endTime: endD,
        quantity: days,
        tariffType: best.tariffType,
        tariffPrice: best.tariffPrice
      }));
      setDateRangeHover(null);
      setTimeout(updateStatusBasedOnDateTime, 100);
    }
  };

  const addVehicle = () => {
    if (selectedVehicles.length < 5) {
      setSelectedVehicles([...selectedVehicles, { vehicleId: '' }]);
    }
  };

  const removeVehicle = (index) => {
    setSelectedVehicles(selectedVehicles.filter((_, i) => i !== index));
  };

  const updateVehicle = (index, field, value) => {
    const updated = [...selectedVehicles];
    updated[index] = { ...updated[index], [field]: value };
    setSelectedVehicles(updated);
  };

  // Verifica disponibilità veicolo in base alle date
  const checkVehicleAvailability = (vehicleId, startDate, endDate, excludeRentalId = null) => {
    if (!startDate || !endDate || !vehicleId) return true;
    
    const start = new Date(startDate);
    const end = new Date(endDate);
    
    // Se si sta modificando un noleggio, trova il rentalGroupId da escludere
    let excludeRentalGroupId = null;
    if (excludeRentalId) {
      const editingRental = rentals.find(r => r.id === excludeRentalId);
      if (editingRental?.rentalGroupId) {
        excludeRentalGroupId = editingRental.rentalGroupId;
      }
    }
    
    // Verifica se ci sono noleggi attivi o programmati che si sovrappongono
    const conflictingRentals = rentals.filter(rental => {
      // Escludi il noleggio corrente se si sta modificando
      if (excludeRentalId && rental.id === excludeRentalId) return false;
      // Escludi tutti i noleggi del gruppo se si sta modificando un noleggio multiplo
      if (excludeRentalGroupId && rental.rentalGroupId === excludeRentalGroupId) return false;
      if (rental.vehicleId !== vehicleId) return false;
      // Considera solo noleggi attivi o programmati (non completati o cancellati)
      if (rental.status === 'completed' || rental.status === 'cancelled') return false;
      
      const rentalStart = new Date(rental.startDate);
      const rentalEnd = new Date(rental.endDate);
      
      // Verifica sovrapposizione date
      return (start <= rentalEnd && end >= rentalStart);
    });
    
    return conflictingRentals.length === 0;
  };

  const calculateTotalPrice = () => {
    let total = 0;
    
    // Calcola i giorni di noleggio
    const start = new Date(formData.startDate);
    const end = new Date(formData.endDate);
    const days = Math.round((end - start) / (1000 * 60 * 60 * 24));
    
    selectedVehicles.forEach((vehicle) => {
      if (vehicle.vehicleId) {
        let basePrice = 0;
        
        // Calcolo in base al tipo di tariffa
        if (formData.tariffType === 'giornaliero') {
          // Prezzo giornaliero: tariffa * giorni
          basePrice = formData.tariffPrice * days;
        } else if (formData.tariffType === 'settimanale') {
          // Prezzo settimanale: prezzo fisso per 7 giorni
          // Se il periodo è multiplo di 7 giorni, usa il prezzo settimanale
          const weeks = Math.ceil(days / 7);
          basePrice = formData.tariffPrice * weeks;
        } else if (formData.tariffType === 'mensile') {
          // Prezzo mensile: prezzo fisso per 30 giorni
          // Se il periodo è multiplo di 30 giorni, usa il prezzo mensile
          const months = Math.ceil(days / 30);
          basePrice = formData.tariffPrice * months;
        } else {
          // Fallback: calcolo giornaliero
          basePrice = formData.tariffPrice * days;
        }
        
        total += basePrice;
      }
    });
    
    // Applica sconto sul totale in base al numero di veicoli
    const vehicleCount = selectedVehicles.filter(v => v.vehicleId).length;
    const discount = discountRates[vehicleCount] || 0;
    return total * (1 - discount);
  };


  const handleDeleteRental = async (rentalId) => {
    if (window.confirm('Sei sicuro di voler eliminare questo noleggio?')) {
      try {
        await api.delete(`/rentals/${rentalId}`);
        await fetchData();
      } catch (error) {
        console.error('Error deleting rental:', error);
        setError('Errore nell\'eliminazione del noleggio');
      }
    }
  };

  const handleEditRental = (rental) => {
    setEditingRental(rental);
    
    // Trova tutti i noleggi del gruppo (se rentalGroupId esiste)
    const groupRentals = rental.rentalGroupId
      ? rentals.filter(r => r.rentalGroupId === rental.rentalGroupId)
      : [rental];
    
    // Carica tutti i veicoli del gruppo
    const vehiclesToLoad = groupRentals.map(r => ({ vehicleId: r.vehicleId }));
    
    // Trova il cliente - prova prima da rental, poi da customers array
    let customer = rental.customer || rental.Customer;
    if (!customer && rental.customerId) {
      customer = customers.find(c => c.id === rental.customerId);
    }
    const customerName = customer ? `${customer.firstName} ${customer.lastName}` : '';
    const customerEmail = customer?.email || '';
    
    setFormData({
      customerId: rental.customerId,
      customerName: customerName,
      rentalVehicleId: rental.vehicleId,
      startDate: new Date(rental.startDate),
      endDate: new Date(rental.endDate),
      startTime: new Date(rental.startDate),
      endTime: new Date(rental.endDate),
      tariffType: 'giornaliero',
      tariffPrice: rental.dailyRate || 25.00,
      totalPrice: rental.totalAmount || rental.totalPrice,
      status: rental.status,
      notes: rental.notes || ''
    });
    
    // Carica tutti i veicoli del gruppo
    setSelectedVehicles(vehiclesToLoad.length > 0 ? vehiclesToLoad : [{ vehicleId: rental.vehicleId }]);
    
    // Imposta il campo di ricerca cliente con il nome del cliente (formato come nel campo)
    setCustomerSearchQuery(customerName && customerEmail ? `${customerName} - ${customerEmail}` : customerName);
    setCustomerSearchResults([]);
    setCustomerSearchAttempted(false);
    setRentalStep(0);
    setDialogOpen(true);
  };

  const resetForm = () => {
    const now = new Date();
    const endDate = new Date(now.getTime() + 24 * 60 * 60 * 1000); // 24 ore da ora
    
    setFormData({
      customerId: '',
      customerName: '',
      rentalVehicleId: '',
      startDate: now,
      endDate: endDate,
      startTime: now,
      endTime: endDate,
      tariffType: 'giornaliero',
      tariffPrice: 25.00,
      quantity: 1,
      totalPrice: '',
      status: 'active',
      notes: '',
      cauzione: 0
    });
    setSelectedVehicles([]);
    setEditingRental(null);
    setRentalStep(0);
    setCustomerSearchQuery('');
    setCustomerSearchResults([]);
    setCustomerSearchAttempted(false);
    setPaymentData({
      paymentMethodId: '',
      accountId: '',
      amount: 0,
      sconto: 0,
      notes: ''
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'success';
      case 'scheduled': return 'warning';
      case 'completed': return 'info';
      case 'cancelled': return 'error';
      default: return 'default';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'active': return 'Attivo';
      case 'scheduled': return 'Programmato';
      case 'completed': return 'Completato';
      case 'cancelled': return 'Annullato';
      default: return status;
    }
  };

  const filteredRentals = rentals.filter(rental => {
    const customerName = rental.customer ? `${rental.customer.firstName} ${rental.customer.lastName}` : '';
    const vehicleName = rental.vehicle ? rental.vehicle.name : '';
    const matchesSearch = customerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         vehicleName.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'all' || rental.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  // Raggruppa per rentalGroupId: una riga per "prenotazione" (tutti i veicoli insieme)
  const displayRows = (() => {
    const byGroup = new Map();
    filteredRentals.forEach(r => {
      const gid = r.rentalGroupId ?? `single-${r.id}`;
      if (!byGroup.has(gid)) byGroup.set(gid, []);
      byGroup.get(gid).push(r);
    });
    return Array.from(byGroup.values()).map(rentalsInGroup => ({
      key: rentalsInGroup[0].rentalGroupId || rentalsInGroup[0].id,
      rentals: rentalsInGroup,
      isGroup: rentalsInGroup.length > 1
    }));
  })();

  const getCustomerName = (rental) => {
    if (rental.customer) {
      return `${rental.customer.firstName} ${rental.customer.lastName}`;
    }
    const customer = customers.find(c => c.id === rental.customerId);
    return customer ? `${customer.firstName} ${customer.lastName}` : 'Cliente non trovato';
  };

  const getVehicleName = (rental) => {
    if (rental.vehicle) {
      return rental.vehicle.name;
    }
    const vehicle = vehicles.find(v => v.id === rental.vehicleId);
    return vehicle ? vehicle.name : 'Mezzo non trovato';
  };

  const getVehicleNamesForRow = (rentalsInRow) => {
    return rentalsInRow.map(r => getVehicleName(r)).join(', ');
  };

  const getTotalAmountForRow = (rentalsInRow) => {
    return rentalsInRow.reduce((sum, r) => sum + parseFloat(r.totalAmount || r.totalPrice || 0), 0);
  };

  const getTotalAmountAfterDiscountForRow = (rentalsInRow) => {
    const total = getTotalAmountForRow(rentalsInRow);
    // Lo sconto viene salvato diviso per ogni rental quando ci sono più veicoli
    // Quindi dobbiamo sommare tutti gli sconti per ottenere lo sconto totale
    const totalDiscount = rentalsInRow.reduce((sum, r) => sum + parseFloat(r.sconto || 0), 0);
    return Math.max(0, total - totalDiscount);
  };

  // Funzioni di ordinamento
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const sortRentals = (rentals) => {
    if (!sortConfig.key) return rentals;
    return [...rentals].sort((a, b) => {
      let aValue, bValue;
      switch (sortConfig.key) {
        case 'customer': aValue = getCustomerName(a).toLowerCase(); bValue = getCustomerName(b).toLowerCase(); break;
        case 'vehicle': aValue = getVehicleName(a).toLowerCase(); bValue = getVehicleName(b).toLowerCase(); break;
        case 'period': aValue = new Date(a.startDate); bValue = new Date(b.startDate); break;
        case 'duration': aValue = calculateDuration(a.startDate, a.endDate); bValue = calculateDuration(b.startDate, b.endDate); break;
        case 'price': aValue = parseFloat(a.totalAmount) || 0; bValue = parseFloat(b.totalAmount) || 0; break;
        case 'status': aValue = a.status; bValue = b.status; break;
        default: return 0;
      }
      if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  };

  const sortDisplayRows = (rows) => {
    if (!sortConfig.key) return rows;
    return [...rows].sort((a, b) => {
      const ra = a.rentals[0];
      const rb = b.rentals[0];
      let aValue, bValue;
      switch (sortConfig.key) {
        case 'customer': aValue = getCustomerName(ra).toLowerCase(); bValue = getCustomerName(rb).toLowerCase(); break;
        case 'vehicle': aValue = getVehicleNamesForRow(a.rentals).toLowerCase(); bValue = getVehicleNamesForRow(b.rentals).toLowerCase(); break;
        case 'period': aValue = new Date(ra.startDate); bValue = new Date(rb.startDate); break;
        case 'duration': aValue = calculateDuration(ra.startDate, ra.endDate); bValue = calculateDuration(rb.startDate, rb.endDate); break;
        case 'price': aValue = getTotalAmountForRow(a.rentals); bValue = getTotalAmountForRow(b.rentals); break;
        case 'status': aValue = ra.status; bValue = rb.status; break;
        default: return 0;
      }
      if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return '↕️';
    return sortConfig.direction === 'asc' ? '↑' : '↓';
  };


  const calculateDuration = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    // Usa differenceInDays che calcola correttamente la differenza tra le date
    // Se noleggio dal 24 al 25, sono 1 giorno (24 ore), non 2
    return differenceInDays(end, start);
  };

  const getActiveRentals = () => rentals.filter(r => r.status === 'active');
  const getCompletedRentals = () => rentals.filter(r => r.status === 'completed');
  const getCancelledRentals = () => rentals.filter(r => r.status === 'cancelled');

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4">
          Gestione Noleggi
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => {
            resetForm();
            setDialogOpen(true);
          }}
        >
          Nuovo Noleggio
        </Button>
      </Box>

      {/* Statistiche */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <DirectionsBike color="primary" sx={{ mr: 2 }} />
                <Box>
                  <Typography color="textSecondary" gutterBottom>
                    Noleggi Attivi
                  </Typography>
                  <Typography variant="h4">
                    {getActiveRentals().length}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <CalendarToday color="success" sx={{ mr: 2 }} />
                <Box>
                  <Typography color="textSecondary" gutterBottom>
                    Completati
                  </Typography>
                  <Typography variant="h4">
                    {getCompletedRentals().length}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <CalendarToday color="info" sx={{ mr: 2 }} />
                <Box>
                  <Typography color="textSecondary" gutterBottom>
                    Programmati
                  </Typography>
                  <Typography variant="h4">
                    {rentals.filter(r => r.status === 'scheduled').length}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Person color="info" sx={{ mr: 2 }} />
                <Box>
                  <Typography color="textSecondary" gutterBottom>
                    Clienti Attivi
                  </Typography>
                  <Typography variant="h4">
                    {new Set(rentals.filter(r => r.status === 'active' || r.status === 'completed').map(r => r.customerId)).size}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Filtri */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Cerca cliente o mezzo"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: <Search sx={{ mr: 1, color: 'text.secondary' }} />
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <FormControl fullWidth>
              <InputLabel>Stato</InputLabel>
              <Select
                value={statusFilter}
                label="Stato"
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <MenuItem value="all">Tutti</MenuItem>
                <MenuItem value="active">Attivi</MenuItem>
                <MenuItem value="scheduled">Programmati</MenuItem>
                <MenuItem value="completed">Completati</MenuItem>
                <MenuItem value="cancelled">Annullati</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>

      {/* Tabella Noleggi */}
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell 
                  onClick={() => handleSort('customer')}
                  sx={{ cursor: 'pointer', '&:hover': { backgroundColor: 'action.hover' } }}
                >
                  Cliente {getSortIcon('customer')}
                </TableCell>
                <TableCell 
                  onClick={() => handleSort('vehicle')}
                  sx={{ cursor: 'pointer', '&:hover': { backgroundColor: 'action.hover' } }}
                >
                  Mezzo {getSortIcon('vehicle')}
                </TableCell>
                <TableCell 
                  onClick={() => handleSort('period')}
                  sx={{ cursor: 'pointer', '&:hover': { backgroundColor: 'action.hover' } }}
                >
                  Periodo {getSortIcon('period')}
                </TableCell>
                <TableCell 
                  onClick={() => handleSort('duration')}
                  sx={{ cursor: 'pointer', '&:hover': { backgroundColor: 'action.hover' } }}
                >
                  Durata {getSortIcon('duration')}
                </TableCell>
                <TableCell 
                  onClick={() => handleSort('price')}
                  sx={{ cursor: 'pointer', '&:hover': { backgroundColor: 'action.hover' } }}
                >
                  Prezzo {getSortIcon('price')}
                </TableCell>
                <TableCell 
                  onClick={() => handleSort('status')}
                  sx={{ cursor: 'pointer', '&:hover': { backgroundColor: 'action.hover' } }}
                >
                  Stato {getSortIcon('status')}
                </TableCell>
                <TableCell>Azioni</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortDisplayRows(displayRows)
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  const r0 = row.rentals[0];
                  const vehicleNames = getVehicleNamesForRow(row.rentals);
                  const totalAmount = getTotalAmountForRow(row.rentals);
                  const totalAmountAfterDiscount = getTotalAmountAfterDiscountForRow(row.rentals);
                  const handleDeleteRow = async () => {
                    const msg = row.rentals.length > 1
                      ? `Eliminare l'intera prenotazione (${row.rentals.length} veicoli)?`
                      : 'Sei sicuro di voler eliminare questo noleggio?';
                    if (!window.confirm(msg)) return;
                    try {
                      for (const r of row.rentals) {
                        await api.delete(`/rentals/${r.id}`);
                      }
                      await fetchData();
                    } catch (err) {
                      setError('Errore nell\'eliminazione del noleggio');
                    }
                  };
                  return (
                <TableRow key={row.key}>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Person sx={{ mr: 1, color: 'text.secondary' }} />
                      {getCustomerName(r0)}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <DirectionsBike sx={{ mr: 1, color: 'text.secondary' }} />
                      {vehicleNames}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box>
                      <Typography variant="body2">
                        {new Date(r0.startDate).toLocaleDateString('it-IT')}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {new Date(r0.endDate).toLocaleDateString('it-IT')}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    {calculateDuration(r0.startDate, r0.endDate)} giorni
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" fontWeight="bold">
                      €{totalAmountAfterDiscount.toFixed(2)}
                    </Typography>
                    {(() => {
                      const totalDiscount = row.rentals.reduce((sum, r) => sum + parseFloat(r.sconto || 0), 0);
                      if (totalDiscount > 0) {
                        return (
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textDecoration: 'line-through' }}>
                            €{totalAmount.toFixed(2)}
                          </Typography>
                        );
                      }
                      return null;
                    })()}
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={getStatusLabel(r0.status)}
                      color={getStatusColor(r0.status)}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Tooltip title="Visualizza Dettagli">
                        <IconButton size="small" onClick={() => { setViewingRentalGroup(row); setViewRentalDialog(true); }}>
                          <ViewIcon />
                        </IconButton>
                      </Tooltip>
                      {r0.status === 'scheduled' && (
                        <Tooltip title="Avvia Noleggio">
                          <IconButton size="small" onClick={() => handleStartRental(r0.id)} color="success">
                            <PlayArrowIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                      {r0.status === 'active' && (
                        <Tooltip title="Riconsegna Veicolo">
                          <IconButton size="small" onClick={() => handleReturnRental(r0.id)} color="primary">
                            <AssignmentReturnIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                      <Tooltip title="Modifica">
                        <IconButton size="small" onClick={() => handleEditRental(r0)}>
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Elimina">
                        <IconButton size="small" onClick={handleDeleteRow} color="error">
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={sortDisplayRows(displayRows).length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(e, newPage) => setPage(newPage)}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
        />
      </Paper>

      {/* Dialog per nuovo/modifica noleggio - Design Moderno */}
      <Dialog 
        open={dialogOpen} 
        onClose={() => {
          setDialogOpen(false);
          setRentalStep(0);
        }} 
        maxWidth="lg" 
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
          }
        }}
      >
        <DialogTitle sx={{ 
          pb: 2, 
          borderBottom: 1, 
          borderColor: 'divider',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderRadius: '8px 8px 0 0'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <DirectionsBike sx={{ fontSize: 28 }} />
            <Typography variant="h5" fontWeight={600}>
              {editingRental ? 'Modifica Noleggio' : 'Nuovo Noleggio'}
            </Typography>
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ p: 3 }}>
          {/* Stepper */}
          <Stepper activeStep={rentalStep} sx={{ mb: 4, pt: 2 }}>
            <Step>
              <StepLabel icon={<Person />}>Cliente</StepLabel>
            </Step>
            <Step>
              <StepLabel icon={<Event />}>Periodo</StepLabel>
            </Step>
            <Step>
              <StepLabel icon={<TwoWheeler />}>Veicoli</StepLabel>
            </Step>
            <Step>
              <StepLabel icon={<AttachMoney />}>Cauzione</StepLabel>
            </Step>
            <Step>
              <StepLabel icon={<Receipt />}>Riepilogo</StepLabel>
            </Step>
          </Stepper>

          <Box sx={{ minHeight: '400px' }}>
            {/* Step 0: Cliente */}
            {rentalStep === 0 && (
              <Card sx={{ p: 3, boxShadow: 2, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                  <Person color="primary" sx={{ fontSize: 28 }} />
                  <Typography variant="h6" fontWeight={600}>
                    Seleziona Cliente
                  </Typography>
                </Box>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={8}>
                    <TextField
                      fullWidth
                      label="Cerca cliente"
                      placeholder="Digita nome, cognome o email e premi Invio"
                      variant="outlined"
                      value={customerSearchQuery}
                      onChange={(e) => {
                        setCustomerSearchQuery(e.target.value);
                        setCustomerSearchAttempted(false);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          setCustomerSearchAttempted(true);
                          const searchTerm = customerSearchQuery.toLowerCase().trim();
                          if (!searchTerm) {
                            setCustomerSearchResults([]);
                            return;
                          }
                          const results = customers.filter((option) => {
                            const fullName = `${option.firstName} ${option.lastName}`.toLowerCase();
                            const email = (option.email || '').toLowerCase();
                            const phone = (option.phone || '').toLowerCase();
                            return (
                              fullName.includes(searchTerm) ||
                              option.firstName.toLowerCase().includes(searchTerm) ||
                              option.lastName.toLowerCase().includes(searchTerm) ||
                              email.includes(searchTerm) ||
                              phone.includes(searchTerm)
                            );
                          });
                          setCustomerSearchResults(results);
                        }
                      }}
                      helperText="Premi Invio per avviare la ricerca"
                    />
                    {customerSearchResults.length > 0 && (
                      <Paper variant="outlined" sx={{ mt: 1.5, maxHeight: 280, overflow: 'auto' }}>
                        <Stack divider={<Divider />} sx={{ py: 0.5 }}>
                          {customerSearchResults.map((option) => (
                            <Box
                              key={option.id}
                              onClick={() => {
                                setFormData(prev => ({
                                  ...prev,
                                  customerId: option.id,
                                  customerName: `${option.firstName} ${option.lastName}`
                                }));
                                setCustomerSearchResults([]);
                                setCustomerSearchQuery(`${option.firstName} ${option.lastName}`);
                              }}
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2,
                                px: 2,
                                py: 1.5,
                                cursor: 'pointer',
                                '&:hover': { bgcolor: 'action.hover' }
                              }}
                            >
                              <Person sx={{ color: 'text.secondary' }} />
                              <Box>
                                <Typography variant="body1" fontWeight={500}>
                                  {option.firstName} {option.lastName}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                  {option.email} • {option.phone}
                                </Typography>
                              </Box>
                            </Box>
                          ))}
                        </Stack>
                      </Paper>
                    )}
                    {customerSearchAttempted && customerSearchResults.length === 0 && (
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        Nessun cliente trovato per &quot;{customerSearchQuery.trim()}&quot;.
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Button
                      fullWidth
                      variant="outlined"
                      size="large"
                      startIcon={<PersonAdd />}
                      onClick={() => setNewCustomerDialog(true)}
                      sx={{ height: '56px', borderWidth: 2, '&:hover': { borderWidth: 2 } }}
                    >
                      Nuovo Cliente
                    </Button>
                  </Grid>
                  {formData.customerId && (
                    <Grid item xs={12}>
                      <Alert icon={<CheckCircle />} severity="success" sx={{ borderRadius: 2 }}>
                        Cliente selezionato: <strong>{formData.customerName}</strong>
                      </Alert>
                    </Grid>
                  )}
                </Grid>
              </Card>
            )}

            {/* Step 1: Periodo e Tariffa - Calendario con selezione inizio/fine e tariffa automatica */}
            {rentalStep === 1 && (() => {
              const monthStart = startOfMonth(calendarMonth);
              const monthEnd = endOfMonth(calendarMonth);
              const calStart = startOfWeek(monthStart, { weekStartsOn: 1 });
              const calEnd = endOfWeek(monthEnd, { weekStartsOn: 1 });
              const allDays = eachDayOfInterval({ start: calStart, end: calEnd });
              const weeks = [];
              for (let i = 0; i < allDays.length; i += 7) weeks.push(allDays.slice(i, i + 7));
              const startD = formData.startDate ? new Date(formData.startDate) : null;
              const endD = formData.endDate ? new Date(formData.endDate) : null;
              const hasRange = startD && endD && !isSameDay(startD, endD);
              const tariffLabels = { giornaliero: 'Giornaliera', settimanale: 'Settimanale', mensile: 'Mensile' };
              // Calcolo giorni: dal 24 al 25 sono 1 giorno (24 ore), non 2
              const daysCount = formData.quantity || (startD && endD ? differenceInDays(new Date(formData.endDate), new Date(formData.startDate)) : 1);
              const pricePerVehicle = (() => {
                const d = daysCount;
                if (formData.tariffType === 'giornaliero') return formData.tariffPrice * d;
                if (formData.tariffType === 'settimanale') return Math.ceil(d / 7) * formData.tariffPrice;
                if (formData.tariffType === 'mensile') return Math.ceil(d / 30) * formData.tariffPrice;
                return formData.tariffPrice * d;
              })();
              const isDayInRange = (day, from, to) => {
                if (!from) return false;
                const d = new Date(day);
                d.setHours(0, 0, 0, 0);
                let f = new Date(from);
                let t = to ? new Date(to) : null;
                f.setHours(0, 0, 0, 0);
                if (t) t.setHours(0, 0, 0, 0);
                if (!t) return isSameDay(d, f);
                if (isBefore(t, f)) [f, t] = [t, f];
                return isSameDay(d, f) || isSameDay(d, t) || (isAfter(d, f) && isBefore(d, t));
              };
              return (
              <Card sx={{ p: 3, boxShadow: 2, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                  <Event color="primary" sx={{ fontSize: 28 }} />
                  <Typography variant="h6" fontWeight={600}>
                    Periodo e Tariffa
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Seleziona la data di inizio (primo clic) e la data di fine (secondo clic). Passa il mouse sui giorni per vedere il periodo evidenziato.
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={8}>
                    <Paper variant="outlined" sx={{ p: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                        <IconButton size="small" onClick={() => setCalendarMonth(subMonths(calendarMonth, 1))}>
                          <ChevronLeft />
                        </IconButton>
                        <Typography variant="subtitle1" fontWeight={600}>
                          {format(calendarMonth, 'MMMM yyyy', { locale: it })}
                        </Typography>
                        <IconButton size="small" onClick={() => setCalendarMonth(addMonths(calendarMonth, 1))}>
                          <ChevronRight />
                        </IconButton>
                      </Box>
                      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 0.5, mb: 0.5 }}>
                        {['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'].map((d) => (
                          <Typography key={d} variant="caption" fontWeight={600} color="text.secondary" sx={{ textAlign: 'center' }}>{d}</Typography>
                        ))}
                      </Box>
                      {weeks.map((week, wi) => (
                        <Box key={wi} sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 0.5 }}>
                          {week.map((day) => {
                            const inCurrentMonth = day.getMonth() === calendarMonth.getMonth();
                            const isStart = startD && isSameDay(day, startD);
                            const isEnd = endD && isSameDay(day, endD);
                            const hoverEnd = dateRangeHover ? new Date(dateRangeHover) : null;
                            const from = startD;
                            const to = hasRange ? endD : (startD && dateRangeHover ? hoverEnd : null);
                            const inRange = isDayInRange(day, from, to);
                            const isTodayDay = isSameDay(day, new Date());
                            return (
                              <Box
                                key={day.toISOString()}
                                onClick={() => applyDateRangeFromCalendar(day)}
                                onMouseEnter={() => { if (startD && !endD) setDateRangeHover(day); }}
                                onMouseLeave={() => setDateRangeHover(null)}
                                sx={{
                                  py: 1,
                                  textAlign: 'center',
                                  borderRadius: 1,
                                  cursor: 'pointer',
                                  bgcolor: inRange ? 'primary.light' : 'transparent',
                                  color: inRange ? 'primary.contrastText' : (inCurrentMonth ? 'text.primary' : 'text.disabled'),
                                  opacity: inCurrentMonth ? 1 : 0.5,
                                  border: isTodayDay ? 2 : 0,
                                  borderColor: 'primary.main',
                                  '&:hover': { bgcolor: inRange ? 'primary.main' : 'action.hover' }
                                }}
                              >
                                <Typography variant="body2" fontWeight={isStart || isEnd ? 700 : 500}>
                                  {format(day, 'd')}
                                </Typography>
                              </Box>
                            );
                          })}
                        </Box>
                      ))}
                    </Paper>
                    <Box sx={{ display: 'flex', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={it}>
                        <TimePicker
                          label="Ora Inizio"
                          value={formData.startTime}
                          onChange={(v) => { setFormData(prev => ({ ...prev, startTime: v })); setTimeout(updateStatusBasedOnDateTime, 100); }}
                          slotProps={{ textField: { size: 'small', sx: { minWidth: 120 } } }}
                        />
                        <TimePicker
                          label="Ora Fine"
                          value={formData.endTime}
                          onChange={(v) => { setFormData(prev => ({ ...prev, endTime: v })); setTimeout(updateStatusBasedOnDateTime, 100); }}
                          slotProps={{ textField: { size: 'small', sx: { minWidth: 120 } } }}
                        />
                      </LocalizationProvider>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Card variant="outlined" sx={{ p: 2, bgcolor: 'grey.50', height: '100%' }}>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>Durata</Typography>
                      <Typography variant="h6" fontWeight={600}>{daysCount} {daysCount === 1 ? 'giorno' : 'giorni'}</Typography>
                      <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 2 }} gutterBottom>Tariffa applicata</Typography>
                      <Typography variant="body1" fontWeight={600}>
                        {tariffLabels[formData.tariffType] || formData.tariffType} — €{Number(formData.tariffPrice).toFixed(2)}
                        {formData.tariffType === 'giornaliero' ? '/giorno' : formData.tariffType === 'settimanale' ? '/settimana' : '/mese'}
                      </Typography>
                      <Divider sx={{ my: 2 }} />
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>Prezzo per veicolo</Typography>
                      <Typography variant="h5" color="primary" fontWeight={700}>€{pricePerVehicle.toFixed(2)}</Typography>
                    </Card>
                  </Grid>
                </Grid>
              </Card>
              );
            })()}

            {/* Step 2: Veicoli */}
            {rentalStep === 2 && (
              <Card sx={{ p: 3, boxShadow: 2, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <TwoWheeler color="primary" sx={{ fontSize: 28 }} />
                    <Typography variant="h6" fontWeight={600}>
                      Veicoli da Noleggiare
                    </Typography>
                  </Box>
                  <Chip 
                    label={`${selectedVehicles.filter(v => v.vehicleId).length} / 5`} 
                    color="primary" 
                    variant="outlined"
                  />
                </Box>
                
                {/* Avviso per veicoli non disponibili */}
                {selectedVehicles.some(v => v.vehicleId && !checkVehicleAvailability(v.vehicleId, formData.startDate, formData.endDate, editingRental?.id)) && (
                  <Alert severity="warning" sx={{ mb: 2 }}>
                    Alcuni veicoli selezionati non sono disponibili nel periodo selezionato. Seleziona un periodo diverso o rimuovi i veicoli non disponibili.
                  </Alert>
                )}
                
                <Stack spacing={2}>
                  {selectedVehicles.map((vehicle, index) => {
                    const isAvailable = vehicle.vehicleId ? checkVehicleAvailability(vehicle.vehicleId, formData.startDate, formData.endDate, editingRental?.id) : true;
                    return (
                    <Card 
                      key={index} 
                      variant="outlined" 
                      sx={{ 
                        p: 2, 
                        border: 2, 
                        borderColor: !isAvailable ? 'error.main' : vehicle.vehicleId ? 'primary.light' : 'grey.300',
                        bgcolor: !isAvailable ? 'error.light' : 'background.paper',
                        transition: 'all 0.2s',
                        '&:hover': { borderColor: !isAvailable ? 'error.dark' : 'primary.main', boxShadow: 2 }
                      }}
                    >
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={10}>
                          <FormControl fullWidth>
                            <InputLabel>Veicolo {index + 1}</InputLabel>
                            <Select
                              value={vehicle.vehicleId}
                              label={`Veicolo ${index + 1}`}
                              onChange={(e) => updateVehicle(index, 'vehicleId', e.target.value)}
                            >
                              {vehicles
                                .filter(v => {
                                  // Filtra i veicoli già selezionati (escludendo quello corrente)
                                  const isSelected = selectedVehicles.some((sv, idx) => 
                                    sv.vehicleId === v.id && idx !== index
                                  );
                                  return !isSelected;
                                })
                                .map((v) => {
                                  // Verifica disponibilità del veicolo
                                  const isAvailable = checkVehicleAvailability(v.id, formData.startDate, formData.endDate, editingRental?.id);
                                  return (
                                    <MenuItem 
                                      key={v.id} 
                                      value={v.id}
                                      disabled={!isAvailable}
                                    >
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <DirectionsBike sx={{ color: isAvailable ? 'text.secondary' : 'error.main' }} />
                                        <Box>
                                          <Typography variant="body1">{v.name}</Typography>
                                          <Typography variant="caption" color={isAvailable ? 'text.secondary' : 'error.main'}>
                                            {v.type} • {v.model}
                                            {!isAvailable && ' • Non disponibile in questo periodo'}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <IconButton
                            color="error"
                            onClick={() => removeVehicle(index)}
                            sx={{ 
                              border: 1, 
                              borderColor: 'error.main',
                              '&:hover': { bgcolor: 'error.light', color: 'white' }
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Card>
                    );
                  })}
                  
                  {selectedVehicles.length < 5 && (
                    <Button
                      variant="outlined"
                      size="large"
                      startIcon={<AddIcon />}
                      onClick={addVehicle}
                      sx={{ 
                        py: 2, 
                        borderWidth: 2, 
                        borderStyle: 'dashed',
                        '&:hover': { borderWidth: 2, bgcolor: 'action.hover' }
                      }}
                    >
                      Aggiungi Veicolo
                    </Button>
                  )}
                </Stack>
              </Card>
            )}

            {/* Step 3: Riepilogo */}
            {/* Step 3: Cauzione */}
            {rentalStep === 3 && (
              <Card sx={{ p: 3, boxShadow: 2, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                  <AttachMoney color="primary" sx={{ fontSize: 28 }} />
                  <Typography variant="h6" fontWeight={600}>
                    Cauzione (Opzionale)
                  </Typography>
                </Box>
                
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Alert severity="info" sx={{ mb: 2 }}>
                      La cauzione è opzionale e verrà restituita alla riconsegna del veicolo se non ci sono danni.
                    </Alert>
                  </Grid>
                  
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Importo Cauzione (€)"
                      type="number"
                      value={formData.cauzione || 0}
                      onChange={(e) => {
                        const cauzione = parseFloat(e.target.value) || 0;
                        setFormData({ ...formData, cauzione });
                      }}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">€</InputAdornment>
                      }}
                      helperText="Lascia 0 se non è richiesta cauzione"
                    />
                  </Grid>
                  
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Note Cauzione"
                      multiline
                      rows={2}
                      value={formData.notesCauzione || ''}
                      onChange={(e) => setFormData({ ...formData, notesCauzione: e.target.value })}
                      placeholder="Note aggiuntive sulla cauzione..."
                    />
                  </Grid>
                </Grid>
              </Card>
            )}
            
            {/* Step 4: Riepilogo */}
            {rentalStep === 4 && (
              <Card sx={{ p: 3, boxShadow: 2, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                  <Receipt color="primary" sx={{ fontSize: 28 }} />
                  <Typography variant="h6" fontWeight={600}>
                    Riepilogo Noleggio
                  </Typography>
                </Box>
                
                <Grid container spacing={3}>
                  {/* Info Cliente */}
                  <Grid item xs={12} md={6}>
                    <Card variant="outlined" sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 2 }}>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Cliente
                      </Typography>
                      <Typography variant="h6" fontWeight={600}>
                        {formData.customerName || 'Non selezionato'}
                      </Typography>
                    </Card>
                  </Grid>

                  {/* Info Periodo */}
                  <Grid item xs={12} md={6}>
                    <Card variant="outlined" sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 2 }}>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Periodo
                      </Typography>
                      <Typography variant="body1" fontWeight={500}>
                        {new Date(formData.startDate).toLocaleDateString('it-IT')} - {new Date(formData.endDate).toLocaleDateString('it-IT')}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {Math.round((new Date(formData.endDate) - new Date(formData.startDate)) / (1000 * 60 * 60 * 24))} giorni
                      </Typography>
                    </Card>
                  </Grid>

                  {/* Veicoli Selezionati */}
                  <Grid item xs={12}>
                    <Card variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Veicoli ({selectedVehicles.filter(v => v.vehicleId).length})
                      </Typography>
                      <Stack spacing={1}>
                        {selectedVehicles.filter(v => v.vehicleId).map((vehicle, idx) => {
                          const vehicleData = vehicles.find(v => v.id === vehicle.vehicleId);
                          return vehicleData ? (
                            <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <DirectionsBike color="primary" />
                              <Typography variant="body2">
                                {vehicleData.name} - {vehicleData.type}
                              </Typography>
                            </Box>
                          ) : null;
                        })}
                      </Stack>
                    </Card>
                  </Grid>

                  {/* Calcolo Prezzo */}
                  <Grid item xs={12}>
                    <Card 
                      variant="outlined" 
                      sx={{ 
                        p: 3, 
                        bgcolor: 'grey.50',
                        border: 2,
                        borderColor: 'primary.main',
                        borderRadius: 2
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                            Prezzo Base
                          </Typography>
                          <Typography variant="h6" color="text.primary" fontWeight={600}>
                            €{(() => {
                              const days = Math.round((new Date(formData.endDate) - new Date(formData.startDate)) / (1000 * 60 * 60 * 24));
                              const vehicleCount = selectedVehicles.filter(v => v.vehicleId).length;
                              let basePrice = 0;
                              
                              if (formData.tariffType === 'giornaliero') {
                                basePrice = formData.tariffPrice * days * vehicleCount;
                              } else if (formData.tariffType === 'settimanale') {
                                const weeks = Math.ceil(days / 7);
                                basePrice = formData.tariffPrice * weeks * vehicleCount;
                              } else if (formData.tariffType === 'mensile') {
                                const months = Math.ceil(days / 30);
                                basePrice = formData.tariffPrice * months * vehicleCount;
                              }
                              
                              return basePrice.toFixed(2);
                            })()}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {(() => {
                              const days = Math.round((new Date(formData.endDate) - new Date(formData.startDate)) / (1000 * 60 * 60 * 24));
                              const vehicleCount = selectedVehicles.filter(v => v.vehicleId).length;
                              if (formData.tariffType === 'giornaliero') {
                                return `${vehicleCount} veicoli × ${days} giorni × €${formData.tariffPrice.toFixed(2)}/giorno`;
                              } else if (formData.tariffType === 'settimanale') {
                                const weeks = Math.ceil(days / 7);
                                return `${vehicleCount} veicoli × ${weeks} settimana/e × €${formData.tariffPrice.toFixed(2)}/settimana`;
                              } else if (formData.tariffType === 'mensile') {
                                const months = Math.ceil(days / 30);
                                return `${vehicleCount} veicoli × ${months} mese/i × €${formData.tariffPrice.toFixed(2)}/mese`;
                              }
                              return '';
                            })()}
                          </Typography>
                        </Grid>
                        {selectedVehicles.filter(v => v.vehicleId).length > 1 && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                              Sconto Applicato
                            </Typography>
                            <Typography variant="h6" color="success.main" fontWeight={700}>
                              -{((discountRates[selectedVehicles.filter(v => v.vehicleId).length] || 0) * 100).toFixed(0)}%
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              Risparmio: €{(() => {
                                const days = Math.round((new Date(formData.endDate) - new Date(formData.startDate)) / (1000 * 60 * 60 * 24));
                                let baseTotal = 0;
                                
                                selectedVehicles.filter(v => v.vehicleId).forEach(() => {
                                  if (formData.tariffType === 'giornaliero') {
                                    baseTotal += formData.tariffPrice * days;
                                  } else if (formData.tariffType === 'settimanale') {
                                    const weeks = Math.ceil(days / 7);
                                    baseTotal += formData.tariffPrice * weeks;
                                  } else if (formData.tariffType === 'mensile') {
                                    const months = Math.ceil(days / 30);
                                    baseTotal += formData.tariffPrice * months;
                                  }
                                });
                                
                                return (baseTotal * (discountRates[selectedVehicles.filter(v => v.vehicleId).length] || 0)).toFixed(2);
                              })()}
                            </Typography>
                          </Grid>
                        )}
                        {formData.cauzione > 0 && (
                          <Grid item xs={12}>
                            <Alert severity="info" sx={{ mb: 1 }}>
                              <Typography variant="body2">
                                <strong>Cauzione:</strong> €{formData.cauzione.toFixed(2)}
                                <br />
                                La cauzione verrà restituita alla riconsegna del veicolo se non ci sono danni.
                              </Typography>
                            </Alert>
                          </Grid>
                        )}
                        <Grid item xs={12}>
                          <Divider sx={{ my: 1 }} />
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant="h6" fontWeight={600} color="text.primary">
                              Totale
                            </Typography>
                            <Typography variant="h4" color="primary.main" fontWeight={700}>
                              €{calculateTotalPrice().toFixed(2)}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>

                  {/* Stato e Note */}
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel>Stato</InputLabel>
                      <Select
                        value={formData.status}
                        label="Stato"
                        onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                      >
                        <MenuItem value="active">Attivo</MenuItem>
                        <MenuItem value="scheduled">Programmato</MenuItem>
                        <MenuItem value="completed">Completato</MenuItem>
                        <MenuItem value="cancelled">Annullato</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Note (opzionale)"
                      multiline
                      rows={3}
                      value={formData.notes}
                      onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                      placeholder="Aggiungi note o informazioni aggiuntive..."
                    />
                  </Grid>
                </Grid>
              </Card>
            )}
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ p: 3, borderTop: 1, borderColor: 'divider', bgcolor: 'grey.50' }}>
          <Button 
            onClick={() => {
              if (rentalStep > 0) {
                setRentalStep(rentalStep - 1);
              } else {
                setDialogOpen(false);
                setRentalStep(0);
              }
            }}
            sx={{ minWidth: 120 }}
          >
            {rentalStep === 0 ? 'Annulla' : 'Indietro'}
          </Button>
          <Box sx={{ flex: 1 }} />
          {rentalStep < 4 ? (
            <Button 
              variant="contained" 
              onClick={() => {
                // Validazione prima di procedere
                if (rentalStep === 0 && !formData.customerId) {
                  setError('Seleziona un cliente per continuare');
                  return;
                }
                if (rentalStep === 2 && selectedVehicles.filter(v => v.vehicleId).length === 0) {
                  setError('Seleziona almeno un veicolo per continuare');
                  return;
                }
                // Step 3 (Cauzione) non richiede validazione, è opzionale
                
                // Se siamo nello step Cliente (0), controlla i documenti prima di procedere
                if (rentalStep === 0) {
                  if (!formData.customerId) {
                    setError('Seleziona un cliente per continuare');
                    return;
                  }
                  
                  // Verifica se il cliente ha i dati del documento
                  const customerData = customers.find(c => c.id === formData.customerId);
                  if (!customerData) {
                    setError('Cliente non trovato');
                    return;
                  }
                  
                  if (!customerData.documentType || !customerData.documentNumber) {
                    console.log('⚠️ Documenti mancanti, apro dialog per richiederli');
                    // Popola i dati esistenti se presenti
                    setDocumentData({
                      documentType: customerData.documentType || 'Carta di Identità',
                      documentNumber: customerData.documentNumber || '',
                      documentIssueDate: customerData.documentIssueDate || null,
                      documentExpiryDate: customerData.documentExpiryDate || null,
                      documentIssuedBy: customerData.documentIssuedBy || ''
                    });
                    setDocumentDialog(true);
                    return; // Ferma l'esecuzione, riprenderà dopo aver salvato i documenti
                  }
                }
                
                setRentalStep(rentalStep + 1);
                setError(null);
              }}
              sx={{ minWidth: 120 }}
            >
              Avanti
            </Button>
          ) : (
            <Button 
              variant="contained" 
              color="success"
              onClick={handleSaveRental}
              startIcon={<CheckCircle />}
              sx={{ minWidth: 180 }}
            >
              {editingRental ? 'Aggiorna Noleggio' : 'Conferma e Vai al Pagamento'}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Dialog per nuovo cliente */}
      <Dialog open={newCustomerDialog} onClose={() => setNewCustomerDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Nuovo Cliente</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Cognome"
                value={newCustomerData.lastName}
                onChange={handleCustomerInputChange('lastName')}
                error={!!customerFormErrors.lastName}
                helperText={customerFormErrors.lastName}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Nome"
                value={newCustomerData.firstName}
                onChange={handleCustomerInputChange('firstName')}
                error={!!customerFormErrors.firstName}
                helperText={customerFormErrors.firstName}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                type="email"
                value={newCustomerData.email}
                onChange={handleCustomerInputChange('email')}
                error={!!customerFormErrors.email}
                helperText={customerFormErrors.email}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <TextField
                  sx={{ width: '80px' }}
                  label="Prefisso"
                  value={newCustomerData.countryCode}
                  onChange={handleCustomerInputChange('countryCode')}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">+</InputAdornment>,
                  }}
                />
                <TextField
                  fullWidth
                  label="Telefono"
                  value={newCustomerData.phone}
                  onChange={handleCustomerInputChange('phone')}
                  error={!!customerFormErrors.phone}
                  helperText={customerFormErrors.phone}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Indirizzo"
                value={newCustomerData.address}
                onChange={handleCustomerInputChange('address')}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Città"
                value={newCustomerData.city}
                onChange={handleCustomerInputChange('city')}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="CAP"
                value={newCustomerData.postalCode}
                onChange={handleCustomerInputChange('postalCode')}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Note"
                multiline
                rows={2}
                value={newCustomerData.notes}
                onChange={handleCustomerInputChange('notes')}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setNewCustomerDialog(false)}>Annulla</Button>
          <Button onClick={handleCreateCustomer} variant="contained">
            Crea Cliente
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog per pagamento */}
      <Dialog open={paymentDialog} onClose={() => setPaymentDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>Pagamento Noleggio</DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Riepilogo Noleggio
              </Typography>
              <Paper sx={{ p: 2, bgcolor: 'grey.50' }}>
                <Typography variant="body2">
                  <strong>Cliente:</strong> {formData.customerName}
                </Typography>
                <Typography variant="body2">
                  <strong>Veicoli:</strong> {selectedVehicles.filter(v => v.vehicleId).map(v => {
                    const vehicle = vehicles.find(ve => ve.id === v.vehicleId);
                    return vehicle?.name;
                  }).filter(Boolean).join(', ') || 'N/A'}
                </Typography>
                <Typography variant="body2">
                  <strong>Periodo:</strong> {new Date(formData.startDate).toLocaleDateString('it-IT')} - {new Date(formData.endDate).toLocaleDateString('it-IT')}
                </Typography>
                <Divider sx={{ my: 1 }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                  <Typography variant="body1">
                    <strong>Totale Noleggio:</strong>
                  </Typography>
                  <Typography variant="h6" color="primary">
                    <strong>€{calculateTotalPrice().toFixed(2)}</strong>
                  </Typography>
                </Box>
              </Paper>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Sconto Applicato (€)"
                type="number"
                value={paymentData.sconto || 0}
                onChange={(e) => {
                  const sconto = parseFloat(e.target.value) || 0;
                  const totale = calculateTotalPrice();
                  const totaleConSconto = Math.max(0, totale - sconto);
                  
                  setPaymentData({
                    ...paymentData,
                    sconto,
                    // Se l'importo pagato è maggiore del nuovo totale con sconto, aggiornalo
                    amount: paymentData.amount > totaleConSconto ? totaleConSconto : paymentData.amount
                  });
                }}
                InputProps={{
                  startAdornment: <InputAdornment position="start">€</InputAdornment>
                }}
                helperText={`Totale originale: €${calculateTotalPrice().toFixed(2)} - Totale con sconto: €${(calculateTotalPrice() - (paymentData.sconto || 0)).toFixed(2)}`}
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Importo Pagato (€)"
                type="number"
                value={paymentData.amount || 0}
                onChange={(e) => {
                  const amount = parseFloat(e.target.value) || 0;
                  setPaymentData({ ...paymentData, amount });
                }}
                InputProps={{
                  startAdornment: <InputAdornment position="start">€</InputAdornment>
                }}
                helperText={(() => {
                  const totaleConSconto = calculateTotalPrice() - (paymentData.sconto || 0);
                  const importoPagato = paymentData.amount || 0;
                  if (importoPagato >= totaleConSconto) {
                    return `Pagamento integrale - Totale con sconto: €${totaleConSconto.toFixed(2)}`;
                  } else {
                    return `Acconto - Residuo: €${(totaleConSconto - importoPagato).toFixed(2)}`;
                  }
                })()}
                required
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <FormControl fullWidth required>
                <InputLabel>Metodo di Pagamento</InputLabel>
                <Select
                  value={paymentData.paymentMethodId}
                  label="Metodo di Pagamento"
                  onChange={(e) => setPaymentData({ ...paymentData, paymentMethodId: e.target.value })}
                >
                  {paymentMethods.map((method) => (
                    <MenuItem key={method.id} value={method.id}>
                      {method.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <FormControl fullWidth required>
                <InputLabel>Conto</InputLabel>
                <Select
                  value={paymentData.accountId}
                  label="Conto"
                  onChange={(e) => setPaymentData({ ...paymentData, accountId: e.target.value })}
                >
                  {accounts.map((account) => (
                    <MenuItem key={account.id} value={account.id}>
                      {account.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12}>
              <Divider />
            </Grid>
            
            <Grid item xs={12}>
              <Paper sx={{ p: 2, bgcolor: 'primary.light', color: 'primary.contrastText' }}>
                <Typography variant="subtitle2" gutterBottom>
                  Riepilogo Pagamento
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography variant="body2">Totale Noleggio:</Typography>
                  <Typography variant="body2">€{calculateTotalPrice().toFixed(2)}</Typography>
                </Box>
                {paymentData.sconto > 0 && (
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="body2">Sconto:</Typography>
                    <Typography variant="body2">-€{paymentData.sconto.toFixed(2)}</Typography>
                  </Box>
                )}
                {(() => {
                  const totaleConSconto = calculateTotalPrice() - (paymentData.sconto || 0);
                  const isAcconto = (paymentData.amount || 0) < totaleConSconto;
                  
                  if (isAcconto) {
                    return (
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography variant="body2">Acconto Versato:</Typography>
                        <Typography variant="body2">€{(paymentData.amount || 0).toFixed(2)}</Typography>
                      </Box>
                    );
                  }
                  return null;
                })()}
                <Divider sx={{ my: 1, bgcolor: 'rgba(255,255,255,0.3)' }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="body1" fontWeight={600}>
                    {(() => {
                      const totaleConSconto = calculateTotalPrice() - (paymentData.sconto || 0);
                      const isAcconto = (paymentData.amount || 0) < totaleConSconto;
                      return isAcconto ? 'Residuo da Pagare:' : 'Totale Pagato:';
                    })()}
                  </Typography>
                  <Typography variant="h6" fontWeight={600}>
                    €{(() => {
                      const totaleConSconto = calculateTotalPrice() - (paymentData.sconto || 0);
                      const isAcconto = (paymentData.amount || 0) < totaleConSconto;
                      return isAcconto 
                        ? (totaleConSconto - (paymentData.amount || 0)).toFixed(2)
                        : (paymentData.amount || 0).toFixed(2);
                    })()}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Note Pagamento"
                multiline
                rows={2}
                value={paymentData.notes}
                onChange={(e) => setPaymentData({ ...paymentData, notes: e.target.value })}
                placeholder="Note aggiuntive sul pagamento..."
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setPaymentDialog(false)}>Annulla</Button>
          <Button 
            onClick={handlePayment} 
            variant="contained" 
            color="success"
            disabled={!paymentData.paymentMethodId || !paymentData.accountId || !paymentData.amount || paymentData.amount <= 0}
          >
            Conferma e Stampa Contratto
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Riconsegna Veicolo */}
      <Dialog open={returnDialog} onClose={() => setReturnDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <AssignmentReturnIcon sx={{ mr: 1 }} />
            Riconsegna Veicolo{returnData.vehicles.length > 1 ? `i (${returnData.vehicles.length})` : ''}
          </Box>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            {returnData.totalDeposit > 0 && (
              <Grid item xs={12}>
                <Alert severity="warning" icon={<Info />}>
                  <Typography variant="body2" fontWeight={600} gutterBottom>
                    ⚠️ Cauzione da Restituire
                  </Typography>
                  <Typography variant="body2">
                    È stata versata una cauzione totale di <strong>€{returnData.totalDeposit.toFixed(2)}</strong>.
                    <br />
                    Controlla lo stato {returnData.vehicles.length > 1 ? 'dei veicoli' : 'del veicolo'} e restituisci la cauzione se {returnData.vehicles.length > 1 ? 'i veicoli sono' : 'il veicolo è'} in buone condizioni.
                  </Typography>
                </Alert>
              </Grid>
            )}
            
            <Grid item xs={12}>
              <Typography variant="body1" fontWeight={600} gutterBottom>
                Inserisci lo stato di ogni veicolo al momento della riconsegna:
              </Typography>
            </Grid>
            
            {returnData.vehicles.map((vehicle, index) => (
              <Grid item xs={12} key={vehicle.vehicleId}>
                <Card variant="outlined" sx={{ p: 2 }}>
                  <Typography variant="subtitle1" fontWeight={600} gutterBottom sx={{ mb: 2 }}>
                    <DirectionsBike sx={{ mr: 1, verticalAlign: 'middle' }} />
                    {vehicle.vehicleName}
                  </Typography>
                  
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth>
                        <InputLabel>Livello Batteria (%)</InputLabel>
                        <Select
                          value={vehicle.batteryLevel}
                          label="Livello Batteria (%)"
                          onChange={(e) => {
                            const updatedVehicles = [...returnData.vehicles];
                            updatedVehicles[index].batteryLevel = e.target.value;
                            setReturnData({ ...returnData, vehicles: updatedVehicles });
                          }}
                        >
                          {[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map(level => (
                            <MenuItem key={level} value={level}>
                              <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <BatteryFullIcon 
                                  sx={{ 
                                    mr: 1, 
                                    color: level >= 80 ? 'success.main' : level >= 50 ? 'warning.main' : 'error.main' 
                                  }} 
                                />
                                {level}%
                                {level >= 80 && <Chip label="Ottimo" color="success" size="small" sx={{ ml: 'auto' }} />}
                                {level >= 50 && level < 80 && <Chip label="Buono" color="warning" size="small" sx={{ ml: 'auto' }} />}
                                {level < 50 && <Chip label="Scarico" color="error" size="small" sx={{ ml: 'auto' }} />}
                              </Box>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Chilometraggio Finale (km)"
                        type="number"
                        value={vehicle.km}
                        onChange={(e) => {
                          const updatedVehicles = [...returnData.vehicles];
                          updatedVehicles[index].km = parseFloat(e.target.value) || 0;
                          setReturnData({ ...returnData, vehicles: updatedVehicles });
                        }}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">km</InputAdornment>
                        }}
                        helperText="Inserisci i km totali del veicolo"
                      />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            ))}
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Note Riconsegna"
                multiline
                rows={3}
                value={returnData.notes}
                onChange={(e) => setReturnData({ ...returnData, notes: e.target.value })}
                placeholder="Eventuali danni, problemi riscontrati, stato generale dei veicoli..."
                helperText="Descrivi lo stato dei veicoli al momento della riconsegna"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setReturnDialog(false)}>Annulla</Button>
          <Button 
            onClick={handleConfirmReturn} 
            variant="contained" 
            color="success"
            disabled={returnData.vehicles.length === 0 || returnData.vehicles.some(v => v.batteryLevel === undefined || v.batteryLevel === null || v.km === undefined || v.km === null)}
          >
            Conferma Riconsegna
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Completamento Pagamento per Avvio Noleggio */}
      <Dialog open={completePaymentDialog} onClose={() => { setCompletePaymentDialog(false); setRentalToStart(null); }} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <AttachMoney color="warning" />
            <Typography variant="h6">Completa il Pagamento</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          {rentalToStart && (
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12}>
                <Alert severity="warning">
                  <Typography variant="body2" fontWeight={600} gutterBottom>
                    Il noleggio non è stato completamente saldato
                  </Typography>
                  <Typography variant="body2">
                    {(() => {
                      const totaleConSconto = parseFloat(rentalToStart.totalAmount || 0) - parseFloat(rentalToStart.sconto || 0);
                      const residuo = totaleConSconto - parseFloat(rentalToStart.totalePagato || 0);
                      return (
                        <>
                          Totale noleggio: <strong>€{parseFloat(rentalToStart.totalAmount || 0).toFixed(2)}</strong>
                          {parseFloat(rentalToStart.sconto || 0) > 0 && (
                            <>
                              <br />
                              Sconto: <strong>-€{parseFloat(rentalToStart.sconto || 0).toFixed(2)}</strong>
                              <br />
                              Totale con sconto: <strong>€{totaleConSconto.toFixed(2)}</strong>
                            </>
                          )}
                          <br />
                          Già pagato: <strong>€{parseFloat(rentalToStart.totalePagato || 0).toFixed(2)}</strong>
                          <br />
                          Residuo: <strong>€{residuo.toFixed(2)}</strong>
                        </>
                      );
                    })()}
                  </Typography>
                </Alert>
              </Grid>
              
              <Grid item xs={12}>
                <FormControl fullWidth required>
                  <InputLabel>Metodo di Pagamento</InputLabel>
                  <Select
                    value={completePaymentData.paymentMethodId}
                    label="Metodo di Pagamento"
                    onChange={(e) => setCompletePaymentData({ ...completePaymentData, paymentMethodId: e.target.value })}
                  >
                    {paymentMethods.map((method) => (
                      <MenuItem key={method.id} value={method.id}>
                        {method.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              
              <Grid item xs={12}>
                <FormControl fullWidth required>
                  <InputLabel>Conto</InputLabel>
                  <Select
                    value={completePaymentData.accountId}
                    label="Conto"
                    onChange={(e) => setCompletePaymentData({ ...completePaymentData, accountId: e.target.value })}
                  >
                    {accounts.map((account) => (
                      <MenuItem key={account.id} value={account.id}>
                        {account.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  label="Importo da Pagare (€)"
                  type="number"
                  value={completePaymentData.amount}
                  onChange={(e) => setCompletePaymentData({ ...completePaymentData, amount: parseFloat(e.target.value) || 0 })}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">€</InputAdornment>
                  }}
                  helperText={(() => {
                    const totaleConSconto = parseFloat(rentalToStart.totalAmount || 0) - parseFloat(rentalToStart.sconto || 0);
                    const residuo = totaleConSconto - parseFloat(rentalToStart.totalePagato || 0);
                    return `Residuo: €${residuo.toFixed(2)}`;
                  })()}
                />
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Note Pagamento"
                  multiline
                  rows={2}
                  value={completePaymentData.notes}
                  onChange={(e) => setCompletePaymentData({ ...completePaymentData, notes: e.target.value })}
                  placeholder="Note aggiuntive sul pagamento..."
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => { setCompletePaymentDialog(false); setRentalToStart(null); }}>
            Annulla
          </Button>
          <Button 
            onClick={handleCompletePaymentAndStart} 
            variant="contained" 
            color="success"
            disabled={!completePaymentData.paymentMethodId || !completePaymentData.accountId || completePaymentData.amount <= 0}
          >
            Completa Pagamento e Avvia Noleggio
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Documenti Cliente */}
      <Dialog
        open={documentDialog}
        onClose={() => setDocumentDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <AssignmentIndIcon color="primary" />
            <Typography variant="h6">Documento di Riconoscimento Richiesto</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Per procedere con il noleggio è necessario inserire i dati del documento di riconoscimento del cliente.
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth required>
                <InputLabel>Tipo Documento</InputLabel>
                <Select
                  value={documentData.documentType}
                  label="Tipo Documento"
                  onChange={(e) => setDocumentData({ ...documentData, documentType: e.target.value })}
                >
                  <MenuItem value="Carta di Identità">Carta di Identità</MenuItem>
                  <MenuItem value="Patente">Patente</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                required
                label="Numero Documento"
                value={documentData.documentNumber}
                onChange={(e) => setDocumentData({ ...documentData, documentNumber: e.target.value })}
                placeholder="es. CA1234567"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Data Rilascio"
                type="date"
                value={documentData.documentIssueDate || ''}
                onChange={(e) => setDocumentData({ ...documentData, documentIssueDate: e.target.value })}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Data Scadenza"
                type="date"
                value={documentData.documentExpiryDate || ''}
                onChange={(e) => setDocumentData({ ...documentData, documentExpiryDate: e.target.value })}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Rilasciato da"
                value={documentData.documentIssuedBy}
                onChange={(e) => setDocumentData({ ...documentData, documentIssuedBy: e.target.value })}
                placeholder="es. Comune di Roma"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDocumentDialog(false)}>Annulla</Button>
          <Button onClick={handleSaveDocuments} variant="contained" color="primary">
            Salva e Continua
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Visualizzazione Dettagli Prenotazione */}
      <Dialog
        open={viewRentalDialog}
        onClose={() => { setViewRentalDialog(false); setViewingRentalGroup(null); }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ pb: 2, borderBottom: 1, borderColor: 'divider' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <ViewIcon color="primary" />
            <Typography variant="h6" fontWeight={600}>
              Dettagli Prenotazione
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          {viewingRentalGroup && (() => {
            const r0 = viewingRentalGroup.rentals[0];
            const customer = r0.customer || customers.find(c => c.id === r0.customerId);
            const allVehicles = viewingRentalGroup.rentals.map(r => {
              const v = vehicles.find(vv => vv.id === r.vehicleId);
              return v || { name: 'N/A', type: '', model: '' };
            });
            const totalAmount = getTotalAmountForRow(viewingRentalGroup.rentals);
            const vehicleNames = getVehicleNamesForRow(viewingRentalGroup.rentals);
            const days = calculateDuration(r0.startDate, r0.endDate);
            return (
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Card variant="outlined" sx={{ p: 2, bgcolor: 'grey.50' }}>
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>Cliente</Typography>
                    <Typography variant="h6">{customer ? `${customer.firstName} ${customer.lastName}` : 'N/A'}</Typography>
                    {customer && (
                      <Box sx={{ mt: 1 }}>
                        {customer.email && <Typography variant="body2" color="text.secondary">📧 {customer.email}</Typography>}
                        {customer.phone && <Typography variant="body2" color="text.secondary">📞 {customer.phone}</Typography>}
                      </Box>
                    )}
                  </Card>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Card variant="outlined" sx={{ p: 2 }}>
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>Periodo</Typography>
                    <Typography variant="body1" fontWeight={500}>
                      {new Date(r0.startDate).toLocaleDateString('it-IT')} - {new Date(r0.endDate).toLocaleDateString('it-IT')}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                      {days} {days === 1 ? 'giorno' : 'giorni'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                      Inizio: {new Date(r0.startDate).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Fine: {new Date(r0.endDate).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}
                    </Typography>
                  </Card>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Card variant="outlined" sx={{ p: 2 }}>
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>Stato</Typography>
                    <Chip label={getStatusLabel(r0.status)} color={getStatusColor(r0.status)} sx={{ mt: 0.5 }} />
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <Card variant="outlined" sx={{ p: 2, bgcolor: 'primary.light', color: 'primary.contrastText' }}>
                    <Typography variant="subtitle1" fontWeight={600} gutterBottom sx={{ mb: 2 }}>
                      Dati Economici
                    </Typography>
                    {(() => {
                      const totalDiscount = viewingRentalGroup.rentals.reduce((sum, r) => sum + parseFloat(r.sconto || 0), 0);
                      const totalDeposit = viewingRentalGroup.rentals.reduce((sum, r) => sum + parseFloat(r.cauzione || 0), 0);
                      const totalDownPayment = viewingRentalGroup.rentals.reduce((sum, r) => sum + parseFloat(r.acconto || 0), 0);
                      const totalPaid = viewingRentalGroup.rentals.reduce((sum, r) => sum + parseFloat(r.totalePagato || 0), 0);
                      const totalAfterDiscount = totalAmount - totalDiscount;
                      const remaining = totalAfterDiscount - totalPaid;
                      const allPaid = viewingRentalGroup.rentals.every(r => r.saldato === true);
                      
                      return (
                        <Box>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography variant="body2">Totale Noleggio:</Typography>
                            <Typography variant="body2" fontWeight={600}>€{totalAmount.toFixed(2)}</Typography>
                          </Box>
                          {totalDiscount > 0 && (
                            <>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                <Typography variant="body2">Sconto:</Typography>
                                <Typography variant="body2" fontWeight={600}>-€{totalDiscount.toFixed(2)}</Typography>
                              </Box>
                              <Divider sx={{ my: 1, bgcolor: 'rgba(255,255,255,0.3)' }} />
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                <Typography variant="body2" fontWeight={600}>Totale con Sconto:</Typography>
                                <Typography variant="body2" fontWeight={700}>€{totalAfterDiscount.toFixed(2)}</Typography>
                              </Box>
                            </>
                          )}
                          {totalDownPayment > 0 && (
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, mt: 1 }}>
                              <Typography variant="body2">Acconto Versato:</Typography>
                              <Typography variant="body2" fontWeight={600}>€{totalDownPayment.toFixed(2)}</Typography>
                            </Box>
                          )}
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, mt: 1 }}>
                            <Typography variant="body2">Totale Pagato:</Typography>
                            <Typography variant="body2" fontWeight={600}>€{totalPaid.toFixed(2)}</Typography>
                          </Box>
                          {remaining > 0 && (
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, mt: 1 }}>
                              <Typography variant="body2">Residuo da Pagare:</Typography>
                              <Typography variant="body2" fontWeight={700} color="warning.main">€{remaining.toFixed(2)}</Typography>
                            </Box>
                          )}
                          {totalDeposit > 0 && (
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, mt: 1 }}>
                              <Typography variant="body2">Cauzione:</Typography>
                              <Typography variant="body2" fontWeight={600}>€{totalDeposit.toFixed(2)}</Typography>
                            </Box>
                          )}
                          <Divider sx={{ my: 1, bgcolor: 'rgba(255,255,255,0.3)' }} />
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant="body1" fontWeight={600}>
                              Stato Pagamento:
                            </Typography>
                            <Chip 
                              label={allPaid ? 'Saldato' : 'In Attesa'} 
                              color={allPaid ? 'success' : 'warning'}
                              size="small"
                              sx={{ bgcolor: allPaid ? 'success.main' : 'warning.main', color: 'white' }}
                            />
                          </Box>
                        </Box>
                      );
                    })()}
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <Card variant="outlined" sx={{ p: 2 }}>
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                      Veicoli Noleggiati ({viewingRentalGroup.rentals.length})
                    </Typography>
                    <Stack spacing={1} sx={{ mt: 1 }}>
                      {allVehicles.map((v, idx) => {
                        const rental = viewingRentalGroup.rentals[idx];
                        return (
                          <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1, bgcolor: 'background.paper', borderRadius: 1 }}>
                            <DirectionsBike color="primary" />
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="body1" fontWeight={500}>{v.name}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                {v.type} • {v.model}
                                {v.serialNumber && ` • SN: ${v.serialNumber}`}
                                {v.color && ` • ${v.color}`}
                              </Typography>
                            </Box>
                            <Typography variant="body2" fontWeight={500}>
                              €{parseFloat(rental.totalAmount || 0).toFixed(2)}
                            </Typography>
                          </Box>
                        );
                      })}
                    </Stack>
                  </Card>
                </Grid>
                {r0.notes && (
                  <Grid item xs={12}>
                    <Card variant="outlined" sx={{ p: 2 }}>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>Note</Typography>
                      <Typography variant="body2">{r0.notes}</Typography>
                    </Card>
                  </Grid>
                )}
              </Grid>
            );
          })()}
        </DialogContent>
        <DialogActions sx={{ p: 3, borderTop: 1, borderColor: 'divider' }}>
          <Button onClick={() => { setViewRentalDialog(false); setViewingRentalGroup(null); }}>
            Chiudi
          </Button>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={() => {
              if (!viewingRentalGroup) return;
              const r0 = viewingRentalGroup.rentals[0];
              const customer = r0.customer || customers.find(c => c.id === r0.customerId);
              const vehiclesData = viewingRentalGroup.rentals.map(r => {
                const v = vehicles.find(vv => vv.id === r.vehicleId);
                return v || { name: 'N/A', type: '', model: '' };
              });
              const companyData = {
                name: companySettings.companyName || 'ELEMOVE SRLS',
                address: `${companySettings.companyAddress || ''} ${companySettings.companyPostalCode || ''} ${companySettings.companyCity || ''}`.trim() || 'VIA RAIOLA 19 80053 CASTELLAMMARE DI STABIA',
                vatNumber: companySettings.companyVatNumber || '09624041217',
                phone: companySettings.companyPhone || '+39 081 123 4567',
                email: companySettings.companyEmail || 'info@elemove.it'
              };
              const days = calculateDuration(r0.startDate, r0.endDate);
              const bestTariff = getBestTariffForDays(days);
              const contractData = {
                startDate: r0.startDate,
                endDate: r0.endDate,
                totalAmount: getTotalAmountForRow(viewingRentalGroup.rentals),
                tariffType: bestTariff.tariffType,
                tariffPrice: bestTariff.tariffPrice
              };
              generateRentalContractPDF(contractData, customer, vehiclesData, companyData);
            }}
          >
            Ristampa Contratto
          </Button>
          <Button
            variant="contained"
            startIcon={<EditIcon />}
            onClick={() => {
              if (!viewingRentalGroup) return;
              setViewRentalDialog(false);
              handleEditRental(viewingRentalGroup.rentals[0]);
            }}
          >
            Modifica
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default RentalManagement;